import React, { useState } from 'react';
import AdminHeader from './AdminHeader.js';
import { useMutation, useQuery } from '@apollo/client';
import { ADD_ADVERTISE, DELETE_ADvertise } from '../graphql/Mutation/Advertise.js';
import { GET_ADVERTISE } from '../graphql/Query/Advertise.js';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomPagination from '../components/Pagination.js';
import useScrollToTop from '../components/useScrollToTop.js';


const AdminAd = () => {
    useScrollToTop();
    const [selectedImage, setSelectedImage] = useState(null);
    const [addAdvertise] = useMutation(ADD_ADVERTISE);
    const [deleteAdvertiseData] = useMutation(DELETE_ADvertise);
    const [page, setPage] = useState(0);
    const [limit] = useState(200);
    const { data: getAdvertise, loading, refetch } = useQuery(GET_ADVERTISE, {
        variables: {
            page: page + 1,
            limit,
            sort: {
                key: "createdAt",
                type: -1
            },
        }
    });

    const formik = useFormik({
        initialValues: {
            image: null,
            title: '',
            caption: '',
        },
        validationSchema: Yup.object({
            image: Yup.mixed().required('Image is required'),
            title: Yup.string()
                .max(50, 'Title must be 50 characters or less')
                .required('Title is required'),
            caption: Yup.string()
                .required('Caption is required'),
        }),
        onSubmit: async (values) => {
            try {
                const data = await addAdvertise({
                    variables: {
                        input: {
                            title: values.title,
                            description: values.caption,
                            image: values.image,
                        },
                    },
                });
                if (data?.data?.addBlog?.status) {
                    toast.success("Advertisement added successfully!");
                    formik.resetForm();
                    refetch();
                }
            } catch (error) {
                toast.error(error.message);
            }
        },
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            formik.setFieldValue('image', reader.result);
        };
        reader.readAsDataURL(file);
    };

    const deleteAdvertise = async (id) => {
        try {
            const data = await deleteAdvertiseData({
                variables: {
                    deleteBlogId: id
                }
            });
            if (data?.data?.deleteBlog) {
                refetch();
                toast.success("Advertisement Deleted successfully!");
            }
        } catch (error) {
            toast.error(error.message);
        }
    };
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
    };

    return (
        <div>
            {/* <AdminHeader /> */}
            <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-8 my-10">
                <div className='max-w-lg mx-auto '>
                    <h2 className="font-semibold">Advertisement To Customer (Notification)</h2>
                    <div className="mb-10 mt-4 p-6 bg-white rounded-lg border border-slate-300">
                        <form
                            onSubmit={formik.handleSubmit}
                            className="mt- space-y-5"
                        >
                            {/* Upload Image */}
                            <div>
                                <label className="text-sm font-medium text-gray-700 block">
                                    Upload Image
                                </label>
                                <input
                                    type="file"
                                    name="image"
                                    onChange={handleImageChange}
                                    className="mt-2 block w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-slate-600 focus:border-slate-600 transition"
                                />
                                {formik.touched.image && formik.errors.image && (
                                    <p className="text-red-500 text-sm mt-1">{formik.errors.image}</p>
                                )}
                            </div>

                            {/* Title */}
                            <div>
                                <label className="text-sm font-medium text-gray-700 block">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    name="title"
                                    value={formik.values.title}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Enter title"
                                    className="mt-2 block w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-slate-600 focus:border-slate-600 transition"
                                />
                                {formik.touched.title && formik.errors.title && (
                                    <p className="text-red-500 text-sm mt-1">{formik.errors.title}</p>
                                )}
                            </div>

                            {/* Caption */}
                            <div>
                                <label className="text-sm font-medium text-gray-700 block">
                                    Caption
                                </label>
                                <textarea
                                    name="caption"
                                    value={formik.values.caption}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Add Caption"
                                    rows={4}
                                    className="mt-2 block w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-slate-600 focus:border-slate-600 transition"
                                />
                                {formik.touched.caption && formik.errors.caption && (
                                    <p className="text-red-500 text-sm mt-1">{formik.errors.caption}</p>
                                )}
                            </div>

                            {/* Date */}
                            <p className="text-sm text-gray-500">06 Jun, 2024</p>

                            {/* Submit Button */}
                            <button
                                type="submit"
                                className="block w-full bg-slate-800 text-white font-medium py-2 rounded-md text-sm hover:bg-slate-900 transition"
                            >
                                Advertisement To Customer
                            </button>
                        </form>
                    </div>

                </div>
                <div className="overflow-auto rounded-xl border border-gray-200 shadow-sm bg-white">
                    {/* Table Header */}
                    <div className="flex justify-between items-center px-4 py-3 border-b bg-slate-50">
                        <h2 className="font-semibold text-sm text-gray-800">
                            Total: {getAdvertise?.getBlogs?.count}
                        </h2>
                    </div>

                    {/* Table */}
                    <table className="min-w-full border-collapse">
                        <thead>
                            <tr className="bg-slate-100">
                                {["Date", "Image", "Title", "Description", "Action"].map((heading) => (
                                    <th key={heading} className="py-3 px-4 text-sm font-semibold text-gray-700 border-b text-left">
                                        {heading}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-gray-500">
                                        Loading...
                                    </td>
                                </tr>
                            ) : getAdvertise?.getBlogs?.count > 0 ? (
                                getAdvertise?.getBlogs?.data.map((item, index) => (
                                    <tr key={index}>
                                        {/* Date */}
                                        <td className="py-3 px-4 text-sm border-b text-gray-700">
                                            {moment(item.createdAt).format("DD/MM/YYYY")}
                                        </td>

                                        {/* Image (Click to Open) */}
                                        <td className="py-3 px-4 border-b">
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="h-16 w-32 object-cover rounded-md border border-gray-200 cursor-pointer hover:opacity-75 transition"
                                                onClick={() => setSelectedImage(item.image)}
                                            />
                                        </td>

                                        {/* Title */}
                                        <td className="py-3 px-4 text-sm border-b text-gray-800 font-medium">
                                            {item.title}
                                        </td>

                                        {/* Description */}
                                        <td className="py-3 px-4 text-sm border-b text-gray-600">
                                            {item.description}
                                        </td>

                                        {/* Delete Button */}
                                        <td className="py-3 px-4 border-b">
                                            <button
                                                onClick={() => deleteAdvertise(item.id)}
                                                className="px-3 py-1.5 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700 transition-all"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-gray-500">
                                        No advertisements found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Image Modal */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                            <div className="relative">
                                <button
                                    className="absolute top-2 right-2 bg-white text-black rounded-full p-2 hover:bg-slate-200 transition"
                                    onClick={() => setSelectedImage(null)}
                                >
                                    ✕
                                </button>
                                <img src={selectedImage} alt="Selected" className="max-w-full max-h-screen rounded-lg" />
                            </div>
                        </div>
                    )}
                </div>

                <div className='justify-end flex'>
                    {/* <div className='mt-2'>
                        <label>
                            Items per page:
                            <select value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
                            <option value={100}>100</option>
                            <option value={50}>50</option>
                            </select>
                        </label>
                    </div> */}

                    {/* <div>
                        <Pagination
                            pageCount={getAdvertise?.getBlogs?.data && Math.ceil(getAdvertise?.getBlogs?.count / limit)}
                            pageNo={page}
                            handlePageClick={(data) => handlePageClick(data)}
                        />
                    </div> */}
                    <div>
                        {getAdvertise?.getBlogs?.count > 0 && (
                            <CustomPagination
                                totalItems={getAdvertise?.getBlogs?.count || 0}
                                limit={limit}
                                pageNo={page}
                                handlePageClick={handlePageClick}
                            />)}

                        {/* Render your content here */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminAd;